@if (loadingCertificate) {
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
}

@if (loadingCertificate == false) {
  <form [formGroup]="certificateForm" novalidate>
    <div>
      <div>
        <mat-form-field class="half-width">
          <mat-label>Certification Type</mat-label>
          <mat-select formControlName="certType">
            @for (certType of availableCertTypes; track certType) {
              <mat-option [value]="certType.id">
                {{certType.description}}
              </mat-option>
            }
          </mat-select>
          @if (certificateForm.controls['certType'].hasError('nonUniqueType')) {
            <mat-error>
              Certificate with this type already exists.
            </mat-error>
          }
        </mat-form-field>
        <div>
          <div id="assignedCertAreas">
            @if (certificate.certProgramAreaDTOs.length == 0) {
              <div>
                No cert areas assigned.
              </div>
            }
            @for (certArea of certificate.certProgramAreaDTOs; track certArea) {
              <div class="certAreaItem">
                <div>
                  {{certArea.areaName}}
                </div>
                <span class="span-spacer"></span>
                <div>
                  <button (click)="removeCertArea(certArea)" title="Remove: {{certArea.areaName}}" type="button" mat-button mat-raised-button color="warn">Remove</button>
                </div>
              </div>
            }
          </div>
          <div id="certAreaSmartSearch" fxLayout="row" fxLayoutAlign="start" class="certAreaItem">
            <mat-form-field class="full-width">
              <mat-label>Cert Area</mat-label>
              <input type="text" matInput formControlName="certAreaInputControl" [matAutocomplete]="auto" placeholder="{{certAreaInputControlPlaceholder}}" />
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFnCertArea" (optionSelected)="certAreaSelected($event.option.value)">
                @for (certAreaOption of certAreasFiltered | async; track certAreaOption) {
                  <mat-option [value]="certAreaOption" title="{{certAreaOption.name}}">
                    {{certAreaOption.name}}
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <div>
              <button type="button" mat-button mat-raised-button color="primary" (click)="addCertArea()" [disabled]="disableAddCertArea" title="Add certification area">Add</button>
            </div>
          </div>
        </div>
        <div>
          <mat-form-field class="date-picker">
            <mat-label>Application Date</mat-label>
            <input matInput [matDatepicker]="certApplicationDate" placeholder="Application Date" formControlName="certApplicationDate">
            <mat-datepicker-toggle matSuffix [for]="certApplicationDate"></mat-datepicker-toggle>
            <mat-datepicker #certApplicationDate></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </div>
  </form>
}
